import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPaymentNotice = createSelector(
  [
    (store: RootState) => store.paymentNoticeDetail.paymentNotice,
    (store: RootState) => store.clients.clients,
  ],
  (paymentNotice, clients) => {
    const client = clients.find(
      (clientItem) => clientItem.identifier === paymentNotice.clientIdentifier
    );
    return { ...paymentNotice, client };
  }
);
